
      // After React renders, fade out the splash screen
      const splash = document.getElementById('app-splash');
      const observer = new MutationObserver(() => {
        if (document.getElementById('root').children.length > 0) {
          splash.style.transition = 'opacity 0.4s ease';
          splash.style.opacity = '0';
          setTimeout(() => splash.remove(), 420);
          observer.disconnect();
        }
      });
      observer.observe(document.getElementById('root'), { childList: true });
    